import React, { useEffect } from 'react';

import { useAppDispatch } from 'prequalificationV2/hooks/useAppDispatch';
import FormHeader from 'prequalificationV2/components/FormHeader';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import { resetAllSteps } from 'prequalificationV2/actions/stages';

const FORM_TITLE = 'Unfortunately, you do not qualify at this time for a loan based on your credit profile';
const FORM_SUBTITLE =
  'If you feel you need assistance, please contact HFS Financial at 855-931-5733 or info@hfsfin.com.';

const NoOptions = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetAllSteps());
    };
  }, []);

  return (
    <>
      <FormHeader title={FORM_TITLE} percent={ProgressBarStatus.Failed} subtitle={FORM_SUBTITLE} />
    </>
  );
};

export default NoOptions;
